import React from 'react';
import { Crown } from 'lucide-react';
import { useWorkspace } from '../context/WorkspaceContext';
import './PremiumBadge.css';

const PremiumBadge = ({ className = '', featureName = 'realDevicesEnabled', title = '' }) => {
    const { currentWorkspace } = useWorkspace();

    // Only show if the workspace doesn't have the feature enabled
    // If quotas are missing, assume it's a free account and show it
    const quotas = currentWorkspace?.subscription?.quotas || currentWorkspace?.quotas || {};
    if (quotas[featureName]) {
        return null;
    }

    return (
        <a
            href="/settings/billing"
            className={`premium-badge ${className}`}
            title={title}
        >
            <Crown size={12} fill="currentColor" />
            <span>Premium</span>
        </a>
    );
};

export default PremiumBadge;
